var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"staking-status",class:{ status: _vm.status },style:({'--color': _vm.renderColor})},[(_vm.status != null)?_c('div',{staticClass:"the-dot"}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.renderText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }